import { CountBadge, StatusBadge } from '@/components/ui/Badge'
import { Button } from '@/components/ui/Button'
import type { Column } from '@/components/ui/DataTable'
import { accentFor } from '@/lib/accent'
import { relativeDate, shortDate } from '@/lib/format'
import type { ClientWithPending } from '@/types'

export function buildColumns({
  onOpen,
}: {
  onOpen: (client: ClientWithPending) => void
}): Column<ClientWithPending>[] {
  return [
    {
      key: 'accent',
      header: '',
      width: '28px',
      render: (c) => (
        <span
          className="block h-2.5 w-2.5 rounded-full"
          style={{ backgroundColor: accentFor(c.id) }}
          aria-hidden
        />
      ),
    },
    {
      key: 'name',
      header: 'Client',
      sortBy: (c) => c.name,
      render: (c) => <span className="font-head text-[13px] font-semibold">{c.name}</span>,
    },
    {
      key: 'domain',
      header: 'Domain',
      width: '240px',
      sortBy: (c) => c.primaryDomain ?? '',
      render: (c) => <span className="font-mono text-[12px] text-ink-muted">{c.primaryDomain}</span>,
    },
    {
      key: 'lastCrawl',
      header: 'Last crawl',
      width: '150px',
      sortBy: (c) => c.lastCrawlAt ?? '',
      render: (c) => (
        <span className="text-ink-muted" title={c.lastCrawlAt ? shortDate(c.lastCrawlAt) : undefined}>
          {relativeDate(c.lastCrawlAt)}
        </span>
      ),
    },
    {
      key: 'pipeline',
      header: 'Pipeline',
      width: '120px',
      sortBy: (c) => c.pipelineStage ?? '',
      // Null until the client's first crawl reaches extraction.
      render: (c) =>
        c.pipelineStage ? <StatusBadge status={c.pipelineStage} /> : <span className="text-ink-faint">—</span>,
    },
    {
      key: 'pending',
      header: 'Pending',
      width: '90px',
      align: 'right',
      // Null from the API until APP-61; sorts and renders as zero.
      sortBy: (c) => c.pendingCount ?? 0,
      render: (c) => <CountBadge count={c.pendingCount ?? 0} />,
    },
    {
      key: 'open',
      header: '',
      width: '80px',
      align: 'right',
      render: (c) => (
        <Button
          size="sm"
          onClick={(e) => {
            e.stopPropagation()
            onOpen(c)
          }}
        >
          Open
        </Button>
      ),
    },
  ]
}
